const ths = [
  {
    id: 7,
    label: 'Observations',
    intlKey: 'table.observations',
    sortable: false
  },
  // {
  //   id: 8,
  //   label: 'Assessor Approval',
  //   intlKey: 'table.assessor_approval',
  //   sortable: false
  // },
  {
    id: 9,
    label: 'Note for AL',
    intlKey: 'table.note_for_al',
    sortable: false
  },
  {
    id: 10,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false
  }
]

export default ths
